import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import { generatePdf } from "./DailyReportPDF";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  base_url,Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { loader_image } from "../_components/Imagepath";
import $ from "jquery";

import Dropdown from 'react-bootstrap/Dropdown';
const SupplychainPackagelistHeadersView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [valueHeader, setValueHeader] = useState({});
  const [valueContents, setValueContents] = useState([]);
    const [permission, setPermission] = useState({});
    const [multiplelocations, setMultiplelocations] = useState({});
  
  
  const [apiData, setApiData] = useState([]);
  const [invoiceGenerated, setInvoiceGenerated] = useState(false);
  // const [pdfUrl, setPdfUrl] = useState("");
  const [showGenerateButton, setShowGenerateButton] = useState(true);
  const [packagingid, setPackagingid] = useState(0);
  // const [existinvoice, setExistinvoice] = useState({});
  useEffect(() => {
        setPermission(FindModuleById(91)); 
console.log(permission);
   axios
      .get(`/supply-chain-packaging-list-header/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.supply_chain_header);
          setValueHeader(response.data.data.supply_chain_header);
          setValueContents(response.data.data.all_contents_details);
          setPackagingid(response.data.data.supply_chain_header_items.id);
         
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);
  

  const handleGenerateInvoice = () => {
    //loader-image-invoice3

    $("#loader-image-invoice3").removeClass('loader-hide');
    $("#loader-image-invoice3").addClass('loader-show');

  console.log(value);
    axios
      .get(`/invoices/generate/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          toast.success(response.data.message);
          // setPdfUrl(response.data.url);
          setInvoiceGenerated(true);
          setShowGenerateButton(false); // Hide the "Generate Invoice" button

          // Get the generated invoice ID and fetch its details
          const invoiceId = response.data.data.invoice.id;
          console.log(invoiceId, "ID idhar hai");
          fetchInvoiceDetails(invoiceId);
          
          $("#loader-image-invoice3").addClass('loader-hide');
          $("#loader-image-invoice3").removeClass('loader-show');
        } else {
          toast.error(response.data.errors);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const fetchInvoiceDetails = (invoiceId) => {
    axios
      .get(`/invoices/view-download/${invoiceId}`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          console.log(response.data.data.invoice);
          setApiData(response.data.data.invoice);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  
  const handleDownload = async () => {
    $("#loader-image").removeClass('loader-hide');
    $("#loader-image").addClass('loader-show');
    axios.get(`/supply-chain-packaging-list-header/pdf/${id}`, {
       responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
   }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
          const containerNumber = value.container_number?.toString().replace(/[^a-zA-Z0-9_-]/g, '') || 'UnknownContainer';
          const invoiceNumber = value.invoice?.invoice_number?.toString().replace(/[^a-zA-Z0-9_-]/g, '') || 'Invoice';
          const fileName = `${invoiceNumber} Packing List ${containerNumber}.pdf`;
        link.download = fileName;
        link.click();
        $("#loader-image").addClass('loader-hide');
        $("#loader-image").removeClass('loader-show');
    })
    .catch(error => {
        console.error('Error downloading PDF:', error);
    });
};
  

   
const generatePdfInvoiceDownloadExcel = async (invoice) => {
     window.open(`${base_url}/invoices/view-download-excel-open/${invoice.id}`, '_blank');
}
  const generatePdfInvoiceDownload2 = async (invoice) => {

    console.log(invoice);
  $("#loader-image-invoice2").removeClass('loader-hide');
  $("#loader-image-invoice").addClass('loader-show');
  axios.get(`/invoices/view-download-pdf/${invoice.id}`, {
     responseType: 'blob',
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
 }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
    //  let file_name = invoice.invoice_number +'.pdf';
       const customerName = invoice.customer?.company_name?.replace(/[^a-zA-Z0-9 ]/g, '') || 'Customer';
      const fileName = `${invoice.date} ${customerName} ${invoice.invoice_number}.pdf`;
      link.download = fileName;
      // link.download = file_name;
      link.click();
      $("#loader-image-invoice2").addClass('loader-hide');
      $("#loader-image-invoice2").removeClass('loader-show');
  })
  .catch(error => {
      console.error('Error downloading PDF:', error);
  });
};


const downloadExcel = (packaging_idd) => {
  console.log(packaging_idd);

  // $("#loader-image2").removeClass('loader-hide2');
  // $("#loader-image2").addClass('loader-show2');
  // axios.get(`/supply-chain-packaging-list-header/excel/${packaging_idd.packagingid}`,  {
  //          //responseType: 'blob',
  //         headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
  //      }).then(response => {
  //           // const blob = new Blob([response.data], { type: 'application/pdf' });
  //           // const link = document.createElement('a');
  //           // link.href = URL.createObjectURL(blob);
  //           // let file_name = 'cabrane.pdf';
  //           // link.download = file_name;
  //           // link.click();
  //           console.log(response);

            window.open(`${base_url}/supply-chain-packaging-list-header/excel-open/${id}`, '_blank');

        //     $("#loader-image2").addClass('loader-hide2');
        //     $("#loader-image2").removeClass('loader-show2');
           
        // })
        // .catch(error => {
        //     console.error('Error downloading PDF:', error);
        // });


}



useEffect(() => {
    var loc = value.location;
    console.log(loc);
  //const locations = loc.split(',');
  const locations = loc ? String(loc).split(',') : [];

 setMultiplelocations(locations);


}, [value]);

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col">
                  <h3 className="page-title">Supply Chain Packing List</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/supplychain-package-lists">
                        Supply Chain Packing List
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Supply Chain Packing List
                    </li>
                  </ul>
                </div>
                <div className="col-auto">
                  
               
                   <div style={{float:"right"}}>
                 
                  <span>
                        {showGenerateButton && (
                    <button
                      className="btn btn-primary me-1"
                      onClick={handleGenerateInvoice}
                    >
                      Generate Invoice  <img id="loader-image-invoice3" className="loader-image loader-hide" src={loader_image}/>  
                    </button>
                  )}
                  {invoiceGenerated && (
                    <div>

                          <Dropdown>
                            <Dropdown.Toggle variant="primary" id="dropdown-basic1">
                              Download Invoice
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item id="save-close"  onClick={() =>  generatePdfInvoiceDownload2(apiData)}  >PDF <i className="fa fa-download" /> <img id="loader-image-invoice2" className="loader-image loader-hide" src={loader_image}/> </Dropdown.Item>
                              <Dropdown.Item id="save-new"   onClick={() => generatePdfInvoiceDownloadExcel(apiData)}  > EXCEL  <i className="fa fa-download"></i></Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>

                    </div>
                     
                   
                  )}
                    </span>
                    

                          <Dropdown>
                            <Dropdown.Toggle variant="primary" id="dropdown-basic">
                              Download Packing List
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item id="save-close"  onClick={() => handleDownload()}  >PDF <i className="fa fa-download" /> <img id="loader-image" className="loader-image loader-hide" src={loader_image}/> </Dropdown.Item>
                              <Dropdown.Item id="save-new"   onClick={() =>downloadExcel({packagingid})}  > EXCEL  <i className="fa fa-download"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/></Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>

                    </div>
                   
                  
                </div>
               
                {/* <div className="col-auto">
                  <button
                    onClick={() => generatePdf(value)}
                    className="btn btn-primary me-1"
                  >
                    <i className="fas fa-file-pdf" />
                  </button>
                </div> */}
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">
                      Supply Chain Packing List Details
                    </h4>
                    <table className="table table-bordered">
                    
                      <tr>
                        <th className="p-3">Expedition Date</th>
                        <td className="p-3">{value.expedition_date}</td>
                      </tr>
                    <tr>
                      <th className="p-3">Container Number</th>
                      <td className="p-3">
                        {value.container_number ? value.container_number : ""}
                      </td>
                    </tr>
                   
                      <tr>
                        <th className="p-3">Contract</th>
                        <td className="p-3">
                          {value.contract_names}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Order</th>
                        <td className="p-3">
                          {value.order_names}
                        </td>
                      </tr>

                      
                      <tr>
                        <th className="p-3">Location</th>
                        <td className="p-3">{value.location_name}</td>
                      </tr>
                     
                      <tr>
                        <th className="p-3">Date of Loading</th>
                        <td className="p-3">{value.date_of_loading}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Seal Number</th>
                        <td className="p-3">{value.seal_number}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Container Number</th>
                        <td className="p-3">{value.container_number}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Shipping Line</th>
                        <td className="p-3">
                        {valueHeader.transport_supplier
                            ? valueHeader.transport_supplier.name
                            : ""}
                          </td>
                      </tr>
                      <tr>
                        <th className="p-3">Total Net Weight</th>
                        <td className="p-3">{value.total_net_weight}KG</td>
                      </tr>
                      <tr>
                        <th className="p-3">Total Brut Weight</th>
                        <td className="p-3">{value.total_brut_weight}KG</td>
                      </tr>
                      <tr>
                        <th className="p-3">TAX</th>
                        <td className="p-3">{value.tax}%</td>
                      </tr>   
                      <tr>
                        <th className="p-3">ETA Date</th>
                        <td className="p-3">{value.eta}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Remarks</th>
                        <td className="p-3">{value.remarks}</td>
                      </tr>
                    </table>
                    <br />
                    <h5 className="card-title">Contents</h5>
                    <br />


<table className="table table-bordered text-center">
  <thead>
    <tr>
      
      <th>Lot Number</th>
            {multiplelocations && multiplelocations.length > 1 && (
              <th>Location</th>
            )}
      <th>Product</th>
      <th>Packaging Type</th>
      <th>Number Of Boxes</th>
      <th>BBD</th>
      <th>Price</th>
      <th>Net Weight</th>
      <th>Gross Weight</th>
                                      
    </tr>
  </thead>
  <tbody>
    {valueContents.map((order_item, index) => (
      <tr key={order_item.product || index}>
        <td style={{ display: 'table-cell', verticalAlign: 'middle' }}>
          {order_item.lot_number}
        </td>
        
              {multiplelocations && multiplelocations.length > 1 && (
               <td style={{ display: 'table-cell', verticalAlign: 'middle' }}>
                {order_item.item_location_name}
              </td>
              
              )}
       
        <td style={{ display: 'table-cell', verticalAlign: 'middle' }}>
          {order_item.producttype.title}
        </td>
         <td style={{ display: 'table-cell', verticalAlign: 'middle' }}>
          {order_item.packagetype?.title}
        </td>
         <td style={{ display: 'table-cell', verticalAlign: 'middle' }}>
          {order_item.number_of_boxes}
        </td>
         <td style={{ display: 'table-cell', verticalAlign: 'middle' }}>
          {order_item.bbd}
        </td>
         <td style={{ display: 'table-cell', verticalAlign: 'middle' }}>
          {order_item.price}
        </td>
         <td style={{ display: 'table-cell', verticalAlign: 'middle' }}>
          {order_item.net_weight}
        </td>
         <td style={{ display: 'table-cell', verticalAlign: 'middle' }}>
          {order_item.gross_weight}
        </td>
    </tr>
  
    ))}
  </tbody>
</table>

                      

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SupplychainPackagelistHeadersView;
